export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/bing.2c5b6d8.svg";